import {
	TFormId,
	TInternalFormName,
	TPTKMId,
	TPTKMInternalFormName,
} from "../Interfaces/AdminInterface"

export const ADMIN_PANEL_FORM_ID_START_STRING = "admin-form-"

export const ADMIN_PANEL_FORM_NAMES = {
	"admin-form-connection": "connection",
	"admin-form-item": "item",
	"admin-form-new-request": "newRequestForm",
	"admin-form-collection": "collection",
	"admin-form-request-table": "requestTableForm",
	"admin-form-saved-form": "savedRequestForm",
	"admin-form-personalize": "personalize",
	"admin-form-email": "email",
} as const

export const ADMIN_PANEL_FORM_IDS: { [k in TInternalFormName]: TFormId } = {
	connection: "admin-form-connection",
	item: "admin-form-item",
	newRequestForm: "admin-form-new-request",
	collection: "admin-form-collection",
	requestTableForm: "admin-form-request-table",
	savedRequestForm: "admin-form-saved-form",
	personalize: "admin-form-personalize",
	email: "admin-form-email",
}

export const PTKM_PANEL_FORM_NAMES = {
	"ptkm-form-deadline": "deadlines",
	"ptkm-form-status": "statuses",
	"ptkm-form-rlakr": "rlakr",
	"ptkm-form-public": "active",
} as const

export const PTKM_FORM_IDS: { [k in TPTKMInternalFormName]: TPTKMId } = {
	deadlines: "ptkm-form-deadline",
	statuses: "ptkm-form-status",
	rlakr: "ptkm-form-rlakr",
	active: "ptkm-form-public",
}
